import { Box } from '@mui/material';
import React, { useState } from 'react';
import { useParams } from 'react-router-dom';

import CustomLoader from 'components/shared/CustomLoader/CustomLoader';
import CustomNavigationTab from 'components/shared/CustomNavigationTab/CustomNavigationTab';

import SimilarCompanies from './Companies';
import Contacts from './Contacts';
import Header from './Header';
import muiStyles from './muiStyles';
import News from './News';
import Overview from './Overview';
import PlatformInsights from './PlatformInsights';
import Relationship from './Relationship';
import { useBusinessDetails } from './useBusinessDetails';

const tabsData = [
  {
    label: 'Relationship',
    Component: <Relationship />,
  },
  {
    label: 'Company Intel',
    Component: <Overview />,
  },

  {
    label: 'Contacts',
    Component: <Contacts />,
  },
  {
    label: 'Platform Insights',
    Component: <PlatformInsights />,
  },
  {
    label: 'News',
    Component: <News />,
  },
  {
    label: 'Similar Companies',
    Component: <SimilarCompanies />,
  },
];

const BusinessSelected = () => {
  const { id } = useParams();
  const { data, loading } = useBusinessDetails(id ?? '');

  const [value, setValue] = useState(0);

  const tabs = tabsData.map((tab, index) => {
    const { label, Component } = tab;

    return {
      label,
      id: index + 1,
      isHidden: value !== index,
      Component,
    };
  });

  const handleChange = (_: React.SyntheticEvent, newValue: number) => {
    sessionStorage.setItem('currentBusinessTab', newValue.toString());
    setValue(newValue);
  };

  if (loading || !data) return <CustomLoader open />;

  return (
    <>
      <Header data={data} />
      <Box sx={muiStyles.content}>
        <CustomNavigationTab tabs={tabs} handleChange={handleChange} value={value} />
      </Box>
    </>
  );
};

export default BusinessSelected;
